<template>
  <div class="page-libs-template">
    <router-view />
  </div>
</template>

<script>
import HeaderLib from '@/components/libs/HeaderLib'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'template-libs',
  components: { HeaderLib },
  computed: {
    ...mapState('library', ['libraryReady']),
  },
  methods: {
    ...mapActions('library', ['getLibrary', 'mfcProcessing']),
  },
  created() {
    if (!this.libraryReady) {
      this.getLibrary().then(() => {
        this.mfcProcessing()
      })
    }
  },
}
</script>

<style lang="scss">
.page-libs-template {
}
</style>
